import { render, staticRenderFns } from "./spextDocs.vue?vue&type=template&id=14f3f32e&"
import script from "./spextDocs.vue?vue&type=script&lang=js&"
export * from "./spextDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports